<template>
  <div class="modalContents__object02">
    <div class="modalContents__object02__menu">
      <div class="modalContents__object02__menu__btn">
        <a href="javascript:void(0)" class="globalModal--btn" title="close" @click="hideModal">
          <span class="fa-stack fa-lg">
            <i class="fa fa-circle-thin fa-stack-2x fa-inverse" aria-hidden="true"></i>
            <i class="fa fa-times fa-stack-1x fa-inverse" aria-hidden="true"></i>
          </span>
        </a>
      </div>
      <div class="modalContents__object02__menu__form">
        <h2>SEARCH</h2>
        <!-- <div class="text-center" style="color:white;">現在製作中</div> -->
        <div class="modalContents__object02__menu__form--search">
          <form action="/search" method="get">
              <div class="input-group">
                  <input type="text" class="form-control" name="word" placeholder="Search Keywords" />
                  <span class="input-group-btn">
                      <button class="btn btn-info modalContents__object02--submit" type="submit">
                          <i class="fa fa-search" aria-hidden="true"></i>
                      </button>
                  </span>
              </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import MultiModalMixin from '../mixins/ModalMixin'

  export default {
    name: "Search",
    mixins: [MultiModalMixin]
  };
</script>


// WEBPACK FOOTER //
// resources/assets/js/vue/component/modal/search.vue